export default "__VITE_ASSET__B_Yqz30M__"